// Public tournament directory.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MapPin, Calendar, DollarSign, Plus } from "lucide-react";

export default function Tournaments() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    let alive = true;
    api.get("/tournaments?status=approved")
      .then(r => { if (alive) setRows(r.data || []); })
      .catch(err => console.warn("[tournaments] load failed", err));
    return () => { alive = false; };
  }, []);

  const filtered = rows.filter(t =>
    !q || (t.name + " " + t.location + " " + (t.age_categories || []).join(" "))
      .toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <div className="text-[11px] font-bold tracking-[0.3em] uppercase text-court">Directory</div>
          <h1 className="font-display font-black text-5xl uppercase tracking-tighter mt-2">Tournaments</h1>
        </div>
        <div className="flex items-center gap-3">
          <input
            data-testid="tournaments-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by name, city, age group…"
            className="w-72 bg-transparent border border-zinc-800 focus:border-court py-2.5 px-3 outline-none text-white text-sm"
          />
          <Link
            to="/tournaments/new"
            data-testid="tournaments-host-btn"
            className="inline-flex items-center gap-2 h-11 px-4 border border-court text-court font-bold tracking-widest uppercase text-xs hover:bg-court hover:text-white transition-colors"
          >
            <Plus className="w-4 h-4" /> Host a Tournament
          </Link>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="border border-zinc-800 p-12 text-center text-zinc-500">
          No tournaments match your search.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map(t => (
            <Link to={`/tournaments/${t.id}`} key={t.id} data-testid={`tournament-card-${t.id}`} className="block border border-zinc-800 hover:border-court p-5 transition-colors">
              <div className="text-[10px] tracking-[0.25em] uppercase text-court">{(t.age_categories || []).join(" · ") || "Open"}</div>
              <h3 className="font-display font-black text-2xl mt-1 tracking-tight">{t.name}</h3>
              <p className="text-xs text-zinc-500 mt-1 font-mono">by {t.organizer_name}</p>

              <div className="mt-4 space-y-1.5 text-sm text-zinc-400">
                <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" />{t.location}</div>
                <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5" />{t.start_date} → {t.end_date}</div>
                <div className="flex items-center gap-2"><DollarSign className="w-3.5 h-3.5" />Entry ${t.entry_fee}</div>
              </div>

              {t.description && <p className="mt-4 text-sm text-zinc-400 line-clamp-3">{t.description}</p>}

              <div className="mt-4 pt-4 border-t border-zinc-900 text-xs font-mono text-zinc-500">
                Contact: {t.contact_info}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
